'use client';
import { orderBy } from 'lodash';
import { useState } from 'react';
import { Box } from '@/src/packages/components/ui/Box';
import { Stack } from '@/src/packages/components/ui/Stack';
import { Divider } from '@/src/packages/components/ui/Divider';
import { Testimonial } from '@/src/packages/components/ui/Testimonial';
import { Button } from '@/src/packages/components/ui/Button';
import { IReview } from '@/src/interfaces/generated/contentful';

export type ITestimonialsListProps = {
  itemsPerPage: number;
  reviews: IReview[];
};

export const TestimonialsList = (props: ITestimonialsListProps) => {
  const { itemsPerPage = 2, reviews } = props;

  const [page, setPage] = useState(1);

  const ordered = orderBy(reviews, (review) => review.fields.date).reverse();

  const totalPages = Math.ceil(reviews.length / itemsPerPage);

  const canLoadMore = page < totalPages;

  const handleLoadMore = () => {
    if (canLoadMore) setPage(page + 1);
  };

  return (
    <Box>
      <Stack divider={<Divider />} spaceY={{ initial: 8, lg: 12 }}>
        {ordered.slice(0, page * itemsPerPage).map((review, i) => {
          return <Testimonial review={review} key={i} />;
        })}
      </Stack>

      {canLoadMore && (
        <Box marginTop="gutter">
          <Button
            onClick={handleLoadMore}
            isBlock={{ initial: true, sm: false }}
          >
            Load more
          </Button>
        </Box>
      )}
    </Box>
  );
};
